import React, {useEffect, useLayoutEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {combineClassNames, reactParserCommonOptions} from '../../../../app/functions';
import closeIconPath from '../../../../assets/icons/x-close-blue-icon.svg';
import './index.scss';
import {useDeviceState} from "../../../../app/device_state";
import ReactHtmlParser from "react-html-parser";
import axios from 'axios';

const CLOSE_TIMEOUT = 250;

const IframePopup = ({handleClose, iframeUrl}) => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [contentPageResult, setContentPageResult] = useState(null);

    useEffect(() => {
        axios.get(iframeUrl).then(response => {
            setContentPageResult(response.data);
            setIsPopupVisible(true);
        })
    }, [iframeUrl]);

    const closePopup = () => {
        setIsPopupVisible(false);
        setIsProcessing(false);
        setTimeout(() => {
            handleClose();
        }, CLOSE_TIMEOUT);
    };

    const closePopupWithoutApproval = () => {
        if (isProcessing) return;
        else setIsProcessing(true);
        closePopup();
    };

    const handleBackdropClick = ({target}) => {
        if (target.classList.contains('backdrop')) {
            closePopupWithoutApproval();
        }
    };

    return (
        <div
            className={combineClassNames(
                'backdrop',
                isPopupVisible && 'active',
            )}
            onClick={handleBackdropClick}
        >
            <div className="data-sharing-popup-iframe">
                <div className="popup-close-container">
                    <button
                        type="button"
                        className="popup-close-button"
                        onClick={closePopupWithoutApproval}
                        aria-label="Close Popup"
                    >
                        <img src={closeIconPath} alt="Close Icon" className="popup-close-button-icon"/>
                    </button>
                </div>
                <div className="popup-grey-container">
                    <div className="inner-text-container">
                        <div>
                            {contentPageResult && ReactHtmlParser(contentPageResult, reactParserCommonOptions())}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IframePopup;
